function Lost() {
  return (
    <div className='bg-white'>
      <h1>You are Lost</h1>
    </div>
  );
}

export default Lost;
